import { procurementAPI } from "../../axios";

export const actions = {
    GetPRResolution(context, data){
        return procurementAPI.get(`PrResolution/Pr/${data}`);
    },
    GetPRResolutionItems(context, data){
        return procurementAPI.get(`PrResolution/PrItems/${data}`);
    },
    UpdatePRResolution(context, data){
        return procurementAPI.put(`PrResolution/Update/${data.id}`, data);
    },
}